import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import DashboardMenuService from "../../../services/KangarooServices/Intelligence/DashboardMenuService";
import toast from "react-hot-toast";

const ProductService = () => {
  const navigate = useNavigate();

  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await DashboardMenuService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await DashboardMenuService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Product & Services" pageTitle="KEF Intelligence" />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button
              className="btn btn-success"
              onClick={() => navigate("/product-service/create")}
            >
              <i className="bi bi-plus-lg"></i> New Menu
            </button>
          </div>{" "}
        </Row>

        <Row xs="1" md="2" lg="3" className="g-4">
          {data?.map((item, index) => {
            return (
              <Col key={item.id}>
                <Card>
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <CardImg
                      top
                      src={`${imageBaseApi}${item?.logoImage?.url}`}
                      alt={item.fileName}
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                  <CardBody>
                    <p>{item?.name}</p>
                    <p className="text-secondary">{item?.url}</p>

                    <div
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </CardBody>
                  <CardFooter>
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => navigate(`/product-service/update/${item?.id}`)}
                      >
                        <i className="ri-edit-line"></i>
                      </Button>
                      <Button
                        size="sm"
                        color="danger"
                        className="d-flex align-items-center gap-1"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </Col>
            );
          })}
        </Row>

        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default ProductService;
